import React from "react"
import { useSelector } from "react-redux";
import { ReflectionActionsEnum } from "../../Shared/ReflectionActionsEnum"
import classes from './ReflectionOpenType.module.css'
import Lines from '../../../assests/reflection/lines.png';
import ScrollLTR from "../../../UI/ScrollLTR";


const ReflectionOpenType = ({ action, question = {}, isStudent, answerValue, setAnswerValue }) => {
    const texts = useSelector(state => state.translate.texts);

    const debounce = (func, delay) => {
        let debounceTimer;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer =
                setTimeout(() => func.apply(context, args), delay);
        }
    }
    let optimisedHandleChange = debounce((e) => setAnswerValue(e.target.value), 700);

    switch (action) {

        case ReflectionActionsEnum.CRUD:
            return (
                <div className={classes.CreateType}>
                    <div className={classes.Text}>{question && question.text ? question.text : <img className={classes.Lines} src={Lines} />}</div>
                    <input
                        className={classes.OpenInput}
                        type='text'
                        readOnly
                        placeholder={texts.writeSomething} />
                </div>
            )

        case ReflectionActionsEnum.View:
            return (
                <div className={classes.CreateType}>
                    <div className={classes.Text}>{question && question.text ? question.text : <img className={classes.Lines} src={Lines} />}</div>
                    <input
                        className={classes.OpenInput}
                        type='text'
                        readOnly={!isStudent}
                        onChange={optimisedHandleChange}
                        defaultValue={answerValue}
                        placeholder={texts.writeSomething} />
                </div>)

        case ReflectionActionsEnum.Report:
            return (
                <div className={classes.ReportType}>
                    <p className={classes.ReportQuestion}>{question.name}</p>
                    <div className={classes.Table}>
                        <ScrollLTR dropStyle={{ height: "221px" }} >
                            <div className={`${classes.TableHeader} ${classes.Line}`}>
                                <div className={classes.Name}>{texts.studentName}</div>
                                <div className={classes.Answer}>{texts.answer}</div>
                            </div>
                            <div>
                                {question.submissions.map((answer, index) => {
                                    return <div className={classes.Line} key={index}>
                                        <div className={classes.RowName}>{answer.submittedByUser?.firstName + ' ' + answer.submittedByUser?.lastName}</div>
                                        <div className={classes.AnswerWrap}>
                                            <div className={classes.Answer}>{answer.solution}</div>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </ScrollLTR>
                    </div>
                </div>)

        default:
            return null
    }

}

export default ReflectionOpenType
